<template>
  <div
    class="panel-card-wrapper"
    :class="{ 'segment-card': isSegmentCard }"
    v-on:click="toggleSegment"
  >
    <div class="number-screen" v-show="isSegmentCard && paramsClient.nb_screen_segment !== 1">
      {{ nuberScreen }}
    </div>
    <div class="time-screen" v-show="!isSegmentCard || paramsClient.nb_screen_segment === 1">
      {{ duration | FormatTime }}
    </div>

    <div class="parent" :class="[{ selected: isSelected }, typecard]">
      <div class="folder small blue" :class="typecard">
        <div
          class="thumb_page tile"
          :class="{
            segment,
            'module-list': isModuleList,
          }"
        >
          <div class="slide tile__media" :class="[{ 'module-list': isModuleList }]">
            <div
              @click="$emit('selected')"
              ref="cardEl"
              class="containerScreen tile__img"
              :class="[{ 'module-list': isModuleList, screen: !isSegmentCard }]"
              :style="{ backgroundImage }"
            >
              <ul class="actions-wrapper" @click.stop="checkTarget" v-if="!isModuleList">
                <!--<li-->
                <!--v-has-permission="'edit_duration_segment_action'"-->
                <!--:title="$t('panels.screenSettings')"-->
                <!--class="fa fa-cogs item-li li-settings "-->
                <!--@click.stop="showSettingPanel()"-->
                <!--&gt;</li>-->
                <v-popover
                  offset="16"
                  container="#editor"
                  popoverClass="card-tooltip"
                  placement="top"
                  default-placement="top"
                  class="more-actions-btn-parent"
                >
                  <!-- This will be the popover target (for the events and position) -->
                  <li
                    :title="$t('panels.editScreen')"
                    class="fa fa-ellipsis-v item-li li-edit more-actions-btn open-menu-style"
                  ></li>
                  <!-- This will be the content of the popover -->
                  <template slot="popover">
                    <custom-panel-card-actions
                      :index="index"
                      :is-segment-card="isSegmentCard"
                      :card="slide"
                      :segment="segment"
                      @selected="$emit('selected')"
                      @duplicated="$emit('duplicated')"
                    ></custom-panel-card-actions>
                  </template>
                </v-popover>
              </ul>
              <div class="place-title" v-if="paramsClient.nb_screen_segment !== 1">
                {{ slide.title }}
              </div>
              <div class="place-title" v-if="paramsClient.nb_screen_segment === 1 && slide.screens">
                {{ slide.screens[0].title }}
              </div>

              <!--
              <div
                v-if="!isModuleList"
                class="toggle-slides"
                v-has-permission="'can_toggle_slides_action'"
                v-show="isSegmentCard"
                @click.stop="toggleSegment"
              >
                <i class="icon-arrow-left" :class="{ rotated: isExtended(slide.uid) }"></i>
              </div>
            -->

              <!--<div class="num-slide tag">{{ index + 1 }}</div>-->
            </div>
            <!--<div class="slide_name" v-if="isModuleList">
              <div
                :id="index"
                class="tile__title"
                :class="[{ 'module-list': isModuleList }]"
                :title="$t('panels.edit_title')"
              >
                {{ slide.title }}
              </div>
            </div>-->
          </div>
        </div>
      </div>
      <!--<div class="slide_name" v-if="!isModuleList">
        <div :id="index" class="tile__title" :title="$t('panels.edit_title')">
          {{ slide.title }}
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HasPermission from '../../core/directives/HasPermission.js';
import CustomPanelCardActions from './CustomPanelCardActions';
import mixin from '../../mixins/Mixin.js';

export default {
  name: 'PanelCard',
  components: {
    CustomPanelCardActions,
  },
  props: {
    typecard: '',
    segment: Object,
    slide: Object,
    index: Number,
    isSelected: Boolean,
    segmenOneScreen: Boolean,
    removable: Boolean,
    showVideoIntro: Object,
    isModuleList: {
      type: Boolean,
      default: false,
    },
    isSegmentCard: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    HasPermission,
  },
  data() {
    return {
      isToggled: false,
      title: this.slide.title,
    };
  },
  mixins: [mixin],
  created() {
    eventHub.$on('toggleSegmentx', this.toggleSegment);
  },
  mounted() {},
  watch: {
    slide: {
      handler(val) {
        this.title = val.title;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      hasVideoIntro: 'slides/getHasVideoIntro',
      currentSlide: 'slides/getCurrent',
      permission: 'getPermissions',
      selectedSlides: 'slides/getSelected',
      isExtended: 'segments/isExtended',
      paramsClient: 'getParamsClients',
    }),
    duration() {
      return this.isSegmentCard ? this.slide.duration : this.slide.options.duration;
    },
    isMultipleLayers() {
      return (
        this.isSegmentCard &&
        !this.isModuleList &&
        this.slide.screens.filter(s => s.type !== 'startGeneric').length > 1
      );
    },
    backgroundImage() {
      if (!this.isModuleList) {
        if (this.isSegmentCard) {
          const firstScreen = this.slide.screens.find(
            s => !s.type.toLowerCase().includes('generic'),
          );
          if (firstScreen && firstScreen.screenShot) {
            return `url(${firstScreen.screenShot})`;
          }
        }
        return `url(${this.slide.screenShot || this.defaultScreenshot})`;
      }
    },
    backgroundImageMedia() {
      if (this.isSegmentCard) {
        const firstScreen = this.slide.screens.find(s => !s.type.toLowerCase().includes('generic'));
        if (firstScreen && firstScreen.screenShot) {
          return {
            'background-image': `url(` + firstScreen.screenShot + `)`,
          };
        }
      }
      return { 'background-image': 'url(' + this.slide.screenShot || this.defaultScreenshot + ')' };
    },
    nuberScreen() {
      let number = 0;
      if (this.isSegmentCard)
        if (this.slide.screens) {
          number = this.slide.screens.length;
          return number.toString();
        } else return number.toString();
    },
  },
  methods: {
    ...mapActions('slides', ['updateSlideTitle']),
    ...mapActions('segments', ['setIndexSlideToAdd', 'setCurrentSegment']),

    checkTarget(event) {
      if (
        !(
          event.target.classList.contains('more-actions-btn') ||
          event.target.parentNode.classList.contains('more-actions-btn-parent')
        )
      ) {
        this.$refs.cardEl.click();
      }
    },

    toggleSegment(isClose) {
      let val = {};
      if (isClose == 'close') {
        val.slide = this.slide;
        val.index = this.index;
        val.close = true;
        this.isToggled = !this.isToggled;
        eventHub.$emit('switchtoggle', val);
        return;
      } else if (!this.isSegmentCard) return;
      val.slide = this.slide;
      val.index = this.index;
      this.isToggled = !this.isToggled;
      eventHub.$emit('switchtoggle', val);

      if (this.isSegmentCard) {
        this.setCurrentSegment(this.slide);
        this.setIndexSlideToAdd(this.index);
      }
    },
    update() {
      this.updateSlideTitle({ title: this.title, uid: this.slide.uid });
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
      this.toggleEditMode();
    },
    showSettingPanel() {
      this.$emit('selected');
      setTimeout(() => {
        const barsEl = document.querySelector('#gjs .gjs-pn-buttons .fa-bars');
        const brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
        const decorationTitleEl = document.querySelector(
          '#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title',
        );
        const durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

        barsEl.click();
        const bodyTitleEl = document.querySelector('#gjs .gjs-layer-title');
        bodyTitleEl.click();

        brushEl.click();
        if (decorationTitleEl) {
          decorationTitleEl.click();
          durationTitleEl.click();
        }
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
$duration: 0.3s;
$iconSize: 40px;
$growFactor: 1.05;

$tileWidth: $width-folder - 10;
$tileHeight: $tileWidth / (16 / 9);
$moveLeft: -($tileWidth * ($growFactor - 1) / 2);
$moveRight: $tileWidth * ($growFactor - 1);

.panel-card-wrapper {
  margin-right: 1em;
}
.card-wrapper:not(.extended),
.panel-card-wrapper:not(.segment-card) {
  .thumb_page {
    &:hover {
      .actions-wrapper {
        opacity: 1;
        visibility: visible;
      }
      .tile__img {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      }
    }
  }
}

.tile {
  position: relative;
  display: inline-block;
  //margin-right: 18px;
  font-size: 20px;
  cursor: pointer;
  &:not(.module-list) {
    transition: 0.3s ease-in-out;
    transform-origin: center;
    //margin-left: 8px;
    &:hover {
      //transform: scale($growFactor);
    }
    /*&.selected {
        transform: scale(1.1);
        margin-right: 30px;
        box-shadow: 0 0 0 2px #1a93f0;
        border-radius: 3px;
        margin-bottom: -5px;
      }*/
    .li-duplicate {
      &.disabled {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.3;
      }
    }
  }
  &__title {
    width: $tileWidth;
    text-align: left;
    padding: 0.2em;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.7);
    height: 2em;
    bottom: 0;
    font-size: 12px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    margin-left: 0px;
    white-space: nowrap;
    &:not(.module-list) {
      position: absolute;
      bottom: 0;
      background-color: transparent;
      color: rgba(0, 0, 0, 0.7);
      padding: 0.5em 0;
    }
    &.module-list {
      background: none;
      height: auto;
      color: #707070;
      padding: 0.5em 0;
    }
  }
  &__media {
    border-radius: 3px;
    &.module-list {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    .segment-type {
      position: absolute;
      right: 0;
      margin: 8px;
      font-size: 0.8em;
      z-index: 2;
      color: #ffffff;
    }
    .close-segment {
      position: absolute;
      right: -11px;
      /* margin: 8px; */
      font-size: 0.8em;
      z-index: 6;
      color: #ffffff;
      top: -11px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .place-title {
      position: absolute;
      bottom: -32px;
      left: 0;
      font-size: 0.6em;
      z-index: 2;
      color: #000000;
      font-weight: 700;
      margin: 2px 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: $width-folder - 20;
    }
    .toggle-slides {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 3;
      font-size: 0.6em;
      background-color: #1a93f0;
      font-weight: 700;
      padding: 3px 6px;
      border-top-left-radius: 3px;
      border-bottom-right-radius: 3px;
      color: #ffffff;
      cursor: pointer;
      i {
        transform: rotate(180deg);
        transition: all 0.3s ease-in-out;
        display: inline-block;
        &.rotated {
          transform: rotate(0);
        }
      }
    }
  }
  &__img {
    width: $tileWidth;
    height: $tileHeight;
    background-size: cover;
    background-position: center;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
    border-radius: 3px;
    position: relative;
    .actions-wrapper {
      position: absolute;
      /*left: 50%;*/
      top: 0%;
      /*margin-top: 0.5em !important;*/
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      font-size: 15px;
      z-index: 1;
      left: 6% !important;
      top: 23% !important;
    }
    &.module-list {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
      &:hover {
        border: 2px solid #2196f3 !important;
        border-radius: 2px;
        /*transition: none;*/
        .close-segment {
          display: block !important;
        }
      }
    }
  }
  &__details {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    font-size: 10px;
    opacity: 0;
    transition: $duration opacity;
  }
}

.num-slide {
  font-size: 12px;
  position: absolute;
  top: -7px;
  right: -10px;
  background: #f44336;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  padding: 1px;
  color: white;
  font-weight: 700;
  z-index: 1;
}

.li-delete {
  color: #f44336;
}
.panel-card-wrapper {
  height: 90px;
  padding-right: 0;
  position: relative;
  transition: padding-right 0.3s ease-in-out;
  /*padding: 5px;*/
  .add-segment-btn {
    position: absolute;
    padding: 3px !important;
    font-size: 1em !important;
    transform: translateY(-50%);
    right: 0;
    top: 50%;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
    margin-right: 6px !important;
    color: #ffffff !important;
    background-color: #2196f3 !important;
    border: none !important;
    border-radius: 12px !important;
  }
  .panel-cards-transitions {
    display: flex;
    flex-direction: row;
  }

  &.segment-card {
    /*&.selected,*/
    /*&:hover {*/
    /*padding-right: 30px;*/
    /*!*border: 2px solid #8d8d8d;*!*/
    /*.actions-wrapper {*/
    /*visibility: visible;*/
    /*opacity: 1;*/
    /*}*/
    /*}*/
  }
  .actions-wrapper {
    visibility: visible;
    opacity: 1;
  }
}
.panel-pages-container .item-li {
  color: #8d8d8d !important;
  font-size: 1.2em !important;
  &.open-menu-style {
    background: #ffff00; //#2d73bc;
    color: #8d8d8d !important;
    border: 1px solid #ffff00; //#2d73bc;
    border-radius: 2px;
    border-bottom-left-radius: 7px;
    padding: 2px;
    &:hover {
      background: #144088;
      color: white !important;
      border: 1px solid #144088;
    }
    &.fa-ellipsis-v {
      transform: rotate(90deg);
      position: absolute;
      bottom: 0;
      right: 0;
      &:before {
        padding: 7px;
      }
    }
  }
}

/*******************/

.tile__img {
  margin: 4px 0;
  background-size: cover;
  background-position: center;
  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
  border-radius: 3px;
  position: relative;
}

/**************************/
.number-screen {
  width: 25px;
  height: 25px;
  position: absolute;
  background-color: #144088;
  z-index: 2;
  border-radius: 25px;
  left: $width-folder - 15;
  top: 0px;
  font-size: 17px;
  color: #ffffff;
}
.time-screen {
  width: 35px;
  height: 20px;
  position: absolute;
  background-color: #144088;
  z-index: 2;
  border-radius: 25px;
  left: 74px;
  top: 0px;
  color: #ffffff;
  font-size: 13px;
}

/* floder  segment   */
.folder {
  position: relative;
  display: inline-block;
  text-align: center;
}
.segment.folder.small {
  margin-top: 8px;
  width: $width-folder;
  height: $height-folder;
  border-radius: 0px 6px 6px 6px;
}

.screen.folder.small {
  border-top-style: dashed;
  border-bottom-style: dashed;
  border-width: 3px;
  border-color: white;
  margin: 3px;
  width: $width-folder - 8;
  height: $height-folder + 4-5;
}

.parent.screen {
  width: $width-folder - 2;
  height: $height-folder + 4;
  border-radius: 3px 3px 3px 3px;
  background-color: #2d73bc;
  //position: absolute;
  &.selected {
    width: $width-folder - 2 +4;
    height: $height-folder + 4 + 4;
    border: solid 2px #ffff00;
    box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.86);
  }
}

.segment.folder:before {
  content: '';
  display: block;
  position: absolute;
}

.segment.folder:after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
}
.segment.folder.small:before {
  top: -8px;
  left: 0;
  width: 32px;
  height: 8px;
  border-radius: 6px 0px 0px 0px;
}
.segment.folder.small:after {
  top: -16px;
  left: 24px;
  border: 8px solid transparent;
}
.folder span,
.segment.folder i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.folder span {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 15px;
  white-space: nowrap;
}
.folder.small i {
  font-size: 37px;
}
/*Available colors*/
.folder.blue {
  background-color: #2d73bc;
}
.folder.blue:before,
.segment.folder.blue span {
  background-color: #2d73bc;
}
.folder.blue:after {
  border-bottom-color: #2d73bc !important;
}
.folder.blue span {
  color: #ffffff;
}
.folder.blue i {
  color: #2d73bc;
}

.parent.screen {
  .actions-wrapper {
    /*left: 0% !important;*/
    /*top: 0% !important;*/
    left: 6% !important;
    top: 23% !important;
    margin-top: 0% !important;
  }
  .more-actions-btn-parent {
    margin-left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// CustomPanelCard.vue?29bb6d96